"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagKey = void 0;
var TagKey;
(function (TagKey) {
    TagKey["API_ENDPOINT_METHOD"] = "http_method";
    TagKey["API_ENDPOINT_ROUTE"] = "route";
    TagKey["API_ENDPOINT_STATUS"] = "http_status";
    TagKey["API_ENDPOINT_STATUS_CLASS"] = "http_status_class";
    TagKey["AUTH_ENGINE"] = "auth_engine";
    TagKey["BASIC_AUTH_SET"] = "basic_auth_set";
    TagKey["CALLER"] = "caller";
    TagKey["DELIVERR_SERVICE"] = "deliverr_service";
    TagKey["DIRECT_CALLER"] = "direct_caller";
    TagKey["DIRECT_CALLER_VERSION"] = "direct_caller_version";
    TagKey["ENV"] = "env";
    TagKey["IS_TEST_SELLER"] = "is_test_seller";
    TagKey["MONITOR_DOMAIN"] = "domain";
    TagKey["MONITOR_SERVICE_HEALTH_CATEGORY"] = "service-health-category";
    TagKey["MONITOR_SERVICE_HEALTH_SLO"] = "service-health-slo";
    TagKey["MONITOR_SUBDOMAIN"] = "subdomain";
    TagKey["MONITOR_TEAM"] = "team";
    TagKey["STATUS"] = "status";
})(TagKey = exports.TagKey || (exports.TagKey = {}));
//# sourceMappingURL=tagKeys.js.map